export class ApplicationLoginLog {
  id: number;
  cyberScore: number;
  cyberScoreThreshold: number;
  applicationName: string;
  firmId: string;
  //  failureReasonList: string[];
  reasonsList: string[];
  reasons: string;
  time: string;
  deviceId: string;
  userId: string;
  databaseId: number;
  failureAttemptsNumber: string;
  constructor() {}
}
